export const initialState = {
  actionProcessing: false,
  users: [],
};
